import {
    GetCidadePorIdService,
    GetCidadeService,
    ListarCidadesService,
} from "../../../../Services/Geral/Endereco/Cidade/CidadeServices";
import { Controller } from "../../../Controller";

export async function ListarCidadesController(idEstado: number) {
    return Controller(ListarCidadesService(idEstado));
}

export async function GetCidadeController(nomeCidade: string) {
    return Controller(GetCidadeService(nomeCidade));
}

export async function GetCidadePorIdController(idCidade: number) {
    return Controller(GetCidadePorIdService(idCidade));
}
